import axios from "axios";
import React, { useEffect } from "react";

function ClearEmpty(item) {  
  if(item === undefined) {    
    item = '';
  }
  return item;
}

export default ClearEmpty;
